// extracted by mini-css-extract-plugin
module.exports = {"container":"_1n5WWK5ad-bv-eC4uvr8pn","cancelBtn":"_3u_ryi7ggmnwFieKvDN_Ey","icon":"_3ptbl_N42yJLGww55cSbvQ","saveBtn":"_3_QPEDZMnJ_7scizjWEC6Y"};